module.exports = __webpack_public_path__ + "img/bgys-roadmap.24722586.png";